var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-empty',{attrs:{"description":"访问的页面跑路了"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }